var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col md:flex-row flex-wrap justify-between"},[_c('div',[_c('pagination-page-size-selector',{attrs:{"table-identifier":_vm.tableIdentifier},on:{"change":_vm.onPageChange}})],1),_c('div',[_c('pagination-page-selector',{attrs:{"table-identifier":_vm.tableIdentifier},on:{"change":_vm.onPageChange}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }